import { combineReducers } from '@reduxjs/toolkit';

import { userApi } from './apis/user';
import { api } from './api';
import companyPageReducer from './companyPage';
import companyProfileSettings from './companyProfileSettings';
import companyReviews from './companyReviews';
import extraReducer from './extraReducer';
import jobsReducer from './jobs';
import localsReducer from './locals';
import modalsReducer from './modals';
import resumeBuilderReducer from './resumeBuilder';
import searchFilterReducer from './searchFilter';
import { trackingReducer } from './tracking';
import userReducer from './user';
import userProfilePageReducer from './userProfilePage';

const reducer = combineReducers({
  user: userReducer,
  locals: localsReducer,
  searchFilter: searchFilterReducer,
  modals: modalsReducer,
  jobs: jobsReducer,
  companyPage: companyPageReducer,
  userProfilePage: userProfilePageReducer,
  resumeBuilder: resumeBuilderReducer,
  extra: extraReducer,
  tracking: trackingReducer,
  [api.reducerPath]: api.reducer,
  [userApi.reducerPath]: userApi.reducer,
  companyProfileSettings,
  companyReviews,
});

export default reducer;
